module.exports = __webpack_public_path__ + "static/media/S36.064ffff2.png";